import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Contact, ContactInfo } from "src/app/models/contact.model";
import { ContactService } from "../../services/contact/contact.service";
import { StorageService } from "../../services/storage/storage.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'nonpayer-dialog',
  templateUrl: './nonpayer-dialog.component.html'
})
export class NonPayerDialogComponent implements OnInit {
  dontshow = false;
  dialogRef?: MatDialogRef<any>;
  contact!: ContactInfo;
  updating = false;
  ecli_url =  environment.URL_ECLI ;

  @ViewChild('nonpayerDialog') nonpayerDialog!: TemplateRef<any>;

  constructor(private _storage: StorageService, private _contact: ContactService,private _router: Router, private _dialog: MatDialog) {}

  ngOnInit(): void {
    this.openDialog();
  }

  /**
   * Opens the CGU dialog if the CGU are not accepted yet.
   * @returns None
   */
  async openDialog() {
    try {
      this.contact = await this._storage.getContactInfo();
      //add condition for dont show
      if (this.contact) {
        let config: MatDialogConfig = new MatDialogConfig();
        config.maxWidth = '850px';
        config.disableClose = true;
        config.closeOnNavigation = false;
        this.dialogRef = this._dialog.open(this.nonpayerDialog, config);
      }
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * Closes the dialog and updates the contact's CGU acceptance date.
   * @returns None
   */
  async closeDialog() {
    if(this.dialogRef) {
      if(this.dontshow) {
       await this._contact.dontShowNonPayerPopin();
      }
      this.dialogRef.close();
      this._router.navigateByUrl('/mes-gln');
    }
  }

  GoToEcli() {
    window.open(this.ecli_url);
  }

}
